import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useLanguage } from "@/hooks/useLanguage";

const AboutHero = () => {
  const { t, localizePath } = useLanguage();

  return (
    <section className="relative bg-primary pt-40 pb-24 overflow-hidden">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent/20 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-white/5 rounded-full blur-3xl -z-10" />

      <div className="container mx-auto px-4 md:px-6">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={localizePath("/")} className="text-primary-foreground/70 hover:text-accent">
                  {t("aboutPage.home")}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-primary-foreground/50" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-accent">{t("aboutPage.breadcrumb")}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-primary-foreground mb-6 leading-tight">
            {t("aboutPage.title1")}{" "}
            <span className="text-accent">{t("aboutPage.titleHighlight")}</span>
          </h1>

          <p className="text-xl md:text-2xl text-primary-foreground/80 max-w-3xl">
            {t("aboutPage.description")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
